import { render } from "./NickNameDialog.vue?vue&type=template&id=c395de26&scoped=true"
import script from "./NickNameDialog.vue?vue&type=script&lang=js"
export * from "./NickNameDialog.vue?vue&type=script&lang=js"

import "./NickNameDialog.vue?vue&type=style&index=0&id=c395de26&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c395de26"]])

export default __exports__